import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="55.97804" cy="5.50389" />
				<g opacity="0.6">
					<path fill="#222222" d="M111.14455,5.47389c-0.10742-0.42334-0.39258-0.7793-0.7832-0.97461
						c-0.53027-0.26562-13.13867-6.47412-26.18945-3.18799C71.12013,4.59694,62.95412,16.03444,62.6133,16.51979
						c-0.25195,0.35693-0.33496,0.80566-0.22852,1.229c0.10742,0.42334,0.39258,0.7793,0.7832,0.97461
						c0.41992,0.21045,8.40918,4.14502,18.19531,4.14502c2.5752,0,5.27539-0.27246,7.99414-0.95703
						c13.05176-3.28564,21.21777-14.72314,21.55859-15.2085C111.16798,6.34596,111.25099,5.89723,111.14455,5.47389z"/>
					<path fill="#222222" d="M27.78517,1.31129C14.73048-1.97484,2.12502,4.23365,1.59474,4.49928
						c-0.39062,0.19531-0.67578,0.55127-0.7832,0.97461c-0.10645,0.42334-0.02344,0.87207,0.22852,1.229
						c0.34082,0.48535,8.50684,11.92285,21.55859,15.2085c2.71973,0.68457,5.41797,0.95703,7.99414,0.95703
						c9.78516,0,17.77539-3.93457,18.19531-4.14502c0.39062-0.19531,0.67578-0.55127,0.7832-0.97461
						c0.10645-0.42334,0.02344-0.87207-0.22852-1.229C49.00197,16.03444,40.83693,4.59694,27.78517,1.31129z"/>
				</g>
				<g>
					<path fill="#222222" d="M64.34875,19.26623l-1.13379-0.52051c-0.42578-0.19531-4.24609-1.90771-7.23633-1.90771
						c-2.98535,0-6.81152,1.71289-7.2373,1.9082l-1.13281,0.51855l-0.71875-1.01855
						C46.81263,18.13635,39.0011,7.22863,27.05286,4.22033C15.10559,1.21252,3.05774,7.12072,2.93762,7.18078L1.84486,7.72637
						L0.35865,5.80303C0.16328,5.5502,0.24637,5.18199,0.53138,5.03756l1.06347-0.53891
						c0.53125-0.26562,13.14062-6.47217,26.19043-3.1875c10.98731,2.76611,18.5127,11.31055,20.82129,14.23242
						c1.65723-0.66406,4.68652-1.70557,7.37207-1.70557c2.68848,0,5.71484,1.04102,7.37207,1.70508
						C65.6593,12.62072,73.18469,4.07727,84.172,1.31115c13.05176-3.28564,25.65918,2.92188,26.18945,3.1875l1.04665,0.53327
						c0.28721,0.14633,0.3713,0.51732,0.17526,0.77319l-1.47195,1.92124l-1.09274-0.54558
						c-0.12109-0.06006-12.16992-5.96924-24.11426-2.96045C72.922,7.23694,65.14368,18.13537,65.06653,18.24524L64.34875,19.26623z"/>
				</g>
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="40.07384" cy="5.39768" />
				<g opacity="0.6">
					<path fill="#222222" d="M78.6904,4.37668c-0.0752-0.29634-0.2748-0.54551-0.54824-0.68223
						c-0.37119-0.18594-9.19707-4.53188-18.33262-2.23159C50.67331,3.76281,44.9571,11.76906,44.71852,12.1088
						c-0.17637,0.24985-0.23447,0.56396-0.15996,0.8603c0.0752,0.29634,0.2748,0.54551,0.54824,0.68223
						c0.29395,0.14731,5.88643,2.90151,12.73672,2.90151c1.80264,0,3.69277-0.19072,5.5959-0.66992
						c9.13623-2.29995,14.85244-10.3062,15.09102-10.64595C78.7068,4.98712,78.76491,4.67301,78.6904,4.37668z"/>
					<path fill="#222222" d="M20.33884,1.46286C11.20055-0.83744,2.37673,3.50851,2.00554,3.69445
						C1.7321,3.83117,1.53249,4.08034,1.45729,4.37668c-0.07451,0.29634-0.01641,0.61045,0.15996,0.8603
						c0.23857,0.33975,5.95479,8.346,15.09101,10.64595c1.90381,0.4792,3.79258,0.66992,5.5959,0.66992
						c6.84961,0,12.44277-2.7542,12.73672-2.90151c0.27344-0.13672,0.47305-0.38589,0.54824-0.68223
						c0.07451-0.29634,0.01641-0.61045-0.15996-0.8603C35.19059,11.76906,29.47507,3.76281,20.33884,1.46286z"/>
				</g>
				<g>
					<path fill="#222222" d="M45.93335,14.03132l-0.79365-0.36436c-0.29805-0.13672-2.97227-1.3354-5.06543-1.3354
						c-2.08974,0-4.76807,1.19902-5.06611,1.33574l-0.79297,0.36299l-0.50312-0.71299c-0.054-0.0769-5.52207-7.7123-13.88584-9.81812
						C11.46313,1.39372,3.02964,5.52946,2.94555,5.5715L2.18062,5.95341L1.14027,4.60707
						c-0.13676-0.17698-0.0786-0.43473,0.12091-0.53583l0.74443-0.37724c0.37188-0.18594,9.19844-4.53052,18.3333-2.23125
						c7.69111,1.93628,12.95889,7.91738,14.5749,9.9627c1.16006-0.46484,3.28057-1.1939,5.16045-1.1939
						c1.88194,0,4.00039,0.72871,5.16045,1.19355c1.61602-2.04565,6.88379-8.02607,14.5749-9.96235
						c9.13623-2.29995,17.96143,2.04531,18.33262,2.23125l0.73266,0.37329c0.20104,0.10243,0.2599,0.36212,0.12268,0.54123
						l-1.03036,1.34487l-0.76492-0.3819c-0.08477-0.04204-8.51894-4.17847-16.87998-2.07231
						c-8.3877,2.11162-13.83252,9.74053-13.88652,9.81743L45.93335,14.03132z"/>
				</g>
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="45.50642" cy="7.78016" />
				<g opacity="0.6">
					<path fill="#222222" d="M88.72694,5.75665c-0.08416-0.33167-0.30757-0.61054-0.61361-0.76356
						C87.69788,4.78498,77.81976-0.0791,67.59505,2.49544C57.36958,5.0696,50.97187,14.03037,50.70485,14.41063
						c-0.1974,0.27964-0.26243,0.6312-0.17903,0.96287c0.08416,0.33167,0.30757,0.61055,0.61361,0.76356
						c0.32899,0.16488,6.58822,3.24744,14.25522,3.24744c2.01755,0,4.13303-0.21346,6.26305-0.74979
						C81.88317,16.06055,88.28088,7.09977,88.5479,6.71952C88.7453,6.43988,88.81033,6.08832,88.72694,5.75665z"/>
					<path fill="#222222" d="M23.41856,2.49544C13.19079-0.0791,3.31496,4.78498,2.89951,4.99309
						c-0.30604,0.15302-0.52944,0.4319-0.6136,0.76356c-0.0834,0.33167-0.01836,0.68323,0.17903,0.96287
						c0.26702,0.38025,6.66473,9.34103,16.8902,11.91518c2.13078,0.53633,4.24474,0.74979,6.26306,0.74979
						c7.66623,0,13.92623-3.08256,14.25522-3.24744c0.30604-0.15302,0.52945-0.4319,0.61361-0.76356
						c0.0834-0.33167,0.01836-0.68323-0.17903-0.96287C40.04098,14.03037,33.64403,5.0696,23.41856,2.49544z"/>
				</g>
				<g>
					<path fill="#222222" d="M52.06451,16.56234l-0.88828-0.40779c-0.33358-0.15302-3.32663-1.49461-5.66934-1.49461
						c-2.33889,0-5.33652,1.34197-5.6701,1.49499l-0.88751,0.40626l-0.56311-0.79799
						c-0.06044-0.08607-6.18042-8.63178-15.54134-10.98866C13.48467,2.41806,4.04571,7.04688,3.9516,7.09393L3.09547,7.52137
						L1.93109,6.01452C1.77803,5.81644,1.84312,5.52796,2.06642,5.41481L2.8996,4.9926
						c0.41621-0.20811,10.2951-5.07066,20.51904-2.49727c8.60806,2.16713,14.50388,8.86131,16.31256,11.15047
						c1.29836-0.52026,3.67168-1.33624,5.77569-1.33624c2.1063,0,4.47733,0.81559,5.77569,1.33585
						c1.80868-2.28954,7.70449-8.98296,16.31256-11.15009C77.82061-0.07882,87.69797,4.78449,88.11342,4.9926l0.82,0.4178
						c0.22501,0.11464,0.2909,0.4053,0.13731,0.60576l-1.15321,1.50521l-0.85612-0.42743
						c-0.09487-0.04705-9.53459-4.67663-18.89245-2.31938c-9.3877,2.36337-15.48167,10.90182-15.54211,10.98789L52.06451,16.56234z"/>
				</g>
			</g>
		);
	}
}


function Alien(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisAlien = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisAlien)) {
		return null;
	}

	return <ThisAlien {...props} />;
}

export default Alien;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/Alien.js